import React from 'react'
import { Header, InfoList } from 'components'
import EditIcon from '../../../../../../views/components/atoms/Svgs/Edit'
import styles from './PortfolioDetails.module.scss'
interface PortfolioDetailsProps {
  portfolioLoaded: boolean
  leaseDetails: Array<any>
  redirect: (url: string) => void
  leaseUrl: string
}

const PortfolioDetails = ({ portfolioLoaded, leaseDetails, redirect, leaseUrl }: PortfolioDetailsProps) => {
  return (
    <section className={styles.root}>
      <Header
        className={styles.header}
        tag="h4"
        text="Lease details"
        trailingIcon={
          portfolioLoaded && (
            <button className={styles.edit} onClick={() => redirect(leaseUrl)}>
              <EditIcon />
            </button>
          )
        }
      />
      <InfoList spacing="sm" items={leaseDetails} />
    </section>
  )
}

export default PortfolioDetails
